import styled from 'styled-components';
import ExploreTextKeys, { ExploreTranslations } from '../sportsbook-explore-text-keys';
import SportsbookSelectionTrackingTags from '../../../sportsbook-selection-tracking-tags';
import breakpoint from '../../../../../../utils/style-utils';
import { useAppSelector } from '~/store/types';
import { isSmallerSelector } from '../../../../../layout/mediaquery';
import { RecommendedBetDto } from '../../../api/sbapi/sbapi-api-model';
import useSportsbookBetslip from '../../../hooks/use-sportsbook-betslip';
import { useCallback } from 'react';
import useOddsFormat from '../../../hooks/use-odds-format';
import Icon, { ICON_BET_BUILDER } from '../../../../../icon';
import usePreCannedRecommendationsWithEventSubscription from '../../../hooks/bet-recommendations/use-pre-canned-recommendations-with-event-subscription';
import { PreCannedRecommendationsCarousel } from '../../../sportsbook-async';
import SportsbookContentHeader from '../../../components/header/sportsbook-content-header';

const Wrapper = styled.div<{ noMarginBottom?: boolean; noPadding?: boolean }>`
	display: flex;
	flex-direction: column;
	gap: 12px;
	width: 100%;
	margin-bottom: ${({ noMarginBottom }) => (noMarginBottom ? '0' : '20px')};
	padding: ${({ noPadding }) => noPadding && '0'};
`;

const LabelIcon = styled(Icon).attrs({ type: ICON_BET_BUILDER, width: 24, height: 24 })`
	fill: var(--main-icons);
	margin-top: 2px;
`;

const StyledContentHeader = styled(SportsbookContentHeader)<{ noPadding?: boolean }>`
	padding: ${({ noPadding }) => (noPadding ? '0' : '0 10px')};

	${breakpoint.lg`
		padding: 0;
	`}
`;

type SportsbookExploreRecommendedPreCannedsProps = {
	translations: ExploreTranslations;
	// prop can be removed once we stop displaying this carousel at the top of explore page for all franchises
	isInColumn?: boolean;
};

const SportsbookExploreRecommendedPreCanneds: React.FC<SportsbookExploreRecommendedPreCannedsProps> = ({
	translations,
	isInColumn = false
}) => {
	const { recommendedBets, isLoading } = usePreCannedRecommendationsWithEventSubscription();
	const { betslipSelectionIds, toggleSelections } = useSportsbookBetslip();
	const isSmall = useAppSelector(isSmallerSelector);
	const { oddsFormat } = useOddsFormat();

	const handleBetClick = useCallback(
		(recommendedBet: RecommendedBetDto) => {
			const selections = recommendedBet.items.map(item => item.selection);
			toggleSelections(selections, SportsbookSelectionTrackingTags.EXPLORE_PRE_CANNEDS);
		},
		[toggleSelections]
	);

	if (!isLoading && recommendedBets?.length === 0) {
		return null;
	}

	return (
		<Wrapper noMarginBottom={!isInColumn}>
			<StyledContentHeader
				noPadding={isInColumn && isSmall}
				title={translations[ExploreTextKeys.PRE_CANNED_CAROUSEL_TITLE]}
				iconElement={<LabelIcon type={ICON_BET_BUILDER} />}
			/>
			<PreCannedRecommendationsCarousel
				recommendedBets={recommendedBets}
				isLoading={isLoading}
				paddingX={isSmall && !isInColumn ? 12 : 0}
				showArrows={!isSmall}
				activeSelectionIds={betslipSelectionIds}
				oddsFormat={oddsFormat}
				onBetClick={handleBetClick}
			/>
		</Wrapper>
	);
};

export default SportsbookExploreRecommendedPreCanneds;
